export class Testimonial {
  public description: string;
  public email: string;
  public firstName: string;
  public id: string;
  public lastName: string;
  public photos: string[];
  public rating: number;
  public values: string[];
  public createdAt: number;
  public updatedAt: number;

  constructor(description: string, email: string, firstName: string, lastName: string, photos: string[], rating: number, values: string[], createdAt: number, updatedAt: number, id?: string) {
    this.description = description;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.photos = photos;
    this.rating = rating;
    this.values = values;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.id = id;
  }

  public static mapFromFirestore(testimonial: any, id: string): Testimonial {
    return new Testimonial(
      testimonial.description,
      testimonial.email,
      testimonial.firstName,
      testimonial.lastName,
      testimonial.photos,
      testimonial.rating,
      testimonial.values,
      testimonial.createdAt,
      testimonial.updatedAt,
      id
    );
  }

  public mapToFirestore(): any {
    return {
      description: this.description,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      photos: this.photos,
      rating: this.rating,
      values: this.values,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }

  public static mapArrayFromFirestore(testimonials: any[]): Testimonial[] {
    var testimonialsArray: Testimonial[] = [];
    testimonials.forEach((testimonial: any) => {
      testimonialsArray.push(Testimonial.mapFromFirestore(testimonial, null));
    });
    return testimonialsArray;
  }

  public static mapArrayToFirestore(testimonials: Testimonial[]): any[] {
    var testimonialsArray = [];
    testimonials.forEach((testimonial: Testimonial) => {
      testimonialsArray.push(testimonial.mapToFirestore());
    });
    return testimonialsArray;
  }
}
